exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-primary,.btn-success,.switch-success>.switch-input:checked~.switch-label{background:#0086ff!important;border-color:#0086ff!important;border-radius:3px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/email-template/List.vue"],"names":[],"mappings":"AACA,8EAIE,6BAA+B,AAC/B,+BAAiC,AACjC,iBAAmB,CACpB","file":"List.vue","sourcesContent":["\n.switch-success > .switch-input:checked ~ .switch-label,\n.btn-success,\n.btn-primary\n{\n  background: #0086FF !important;\n  border-color: #0086FF !important;\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b4466a8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/email-template/List.vue
// module id = 2392
// module chunks = 0